import styled from 'styled-components';

export const Title = styled.h4`
  color: #fff !important;
  margin: 0 !important;
  font-size: 1em !important;
  font-weight: normal !important;
`;
